import { Link } from "react-router-dom";
import { SERVICE_CITIES, cityAnchor } from "@/lib/serviceAreas";

export function ServiceArea({ service }) {
  const digital = service?.category_slug === "website-app-development";
  const professional = service?.service_type === "professional";
  return (
    <section className="mt-10 rounded-2xl border border-slate-200 bg-slate-50 p-6" aria-labelledby="service-area-heading" data-testid="service-area">
      <h2 id="service-area-heading" className="font-heading text-xl font-bold text-[#0a192f]">
        {service ? `${service.name}: service across India` : "Service coverage across India"}
      </h2>
      <p className="mt-3 text-sm leading-relaxed text-slate-600">
        We support business enquiries across India from our office in Satna, Madhya Pradesh, over call and WhatsApp. Share your city and state when requesting a quote.
        {digital ? " For a digital project, include your audience, required features and delivery needs so we can agree the scope remotely."
          : professional ? " For professional assistance, include the relevant period, records available and any deadline so the required scope can be reviewed."
          : " For registrations and licensing, the business activity, premises location and responsible authority determine the applicable process and document checklist."}
      </p>
      <Link to={service ? `/service-areas?service=${encodeURIComponent(service.slug)}` : "/service-areas"} className="mt-4 inline-block text-sm font-bold text-[#b07f0a] underline underline-offset-4" data-testid="national-service-coverage-link">
        View service areas across India
      </Link>
      <p className="mt-4 text-sm font-semibold text-slate-700">Regional details: Madhya Pradesh</p>
      <ul className="mt-2 flex flex-wrap gap-x-4 gap-y-2 text-sm" aria-label="Existing Madhya Pradesh regional service locations">
        {SERVICE_CITIES.map((city) => (
          <li key={city}><Link to={`/madhya-pradesh#${cityAnchor(city)}`} className="font-semibold text-[#b07f0a] underline underline-offset-4">{city}</Link></li>
        ))}
      </ul>
      <p className="mt-3 text-sm leading-relaxed text-slate-600">
        The cities above are regional service areas, not additional offices. Availability, applicable requirements, any in-person steps and charges are confirmed for your location before work begins.
      </p>
      <Link to={service ? `/contact?service=${service.slug}` : "/contact"} className="mt-4 inline-block text-sm font-bold text-[#0a192f] underline decoration-[#d4a017] underline-offset-4">
        {service ? `Check availability for ${service.name}` : "Discuss your service and location"}
      </Link>
    </section>
  );
}
